<div ng-controller="transferOwnershipController as ctrl" class="modal-view transfer-ownership">
    <section ng-show="ctrl.running">
        <h2 class="down">{{'admin.workflows.transferOwnership.running'|translate}}</h2>
        <div class="index-status options">
            <i class="fa fa-cog fa-spin fa-fw"></i>
            <div>{{'admin.workflows.transferOwnership.running'|translate}}</div>
            <div class="index-progress" style="float:right">{{ctrl.message}}</div>
        </div>
        <div class="index-status options">
            <button ng-click="ctrl.abort()">{{'admin.updateIndex.cancel'|translate}}</button>
        </div>
    </section>

    <section ng-show="ctrl.workDone">
        <h2 class="down">{{'admin.workflows.transferOwnership.running'|translate}}</h2>
        <div class="index-status options">
            <i class="fa fa-check fa-lg"></i>
            <div class="index-progress" style="float: right">{{ctrl.message}}</div>
        </div>
    </section>

    <div ng-show="!ctrl.running && !ctrl.workDone">
        <section>
            <h2 class="down">{{'admin.workflows.transferOwnership.oldOwners'|translate}}</h2>
            <div class="list old-owner-list">
                <div class="list-filter list-filter-tools">
                    <div centuri-list-filter class="list-filter-elements" config="ctrl.oldOwnerFilterConfig" callback="ctrl.oldOwnerFilterCallback"></div>
                </div>
                <div id="old-owner-list-component"></div>
            </div>
        </section>


        <section>
            <h2 class="down">{{'admin.workflows.transferOwnership.documentsList'|translate}}</h2>
            <div class="list workflow-list">
                <div class="list-filter list-filter-tools">
                    <div centuri-list-filter ng-if="ctrl.ownerSelected" class="list-filter-elements" config="ctrl.documentsFilterConfig" callback="ctrl.documentsFilterCallback"></div>
                </div>
                <div id="workflow-list-component"></div>
            </div>
            <div class="options" ng-if="ctrl.oldOwnerId">
                <label><span>{{'admin.workflows.transferOwnership.selectAll'|translate}}</span><input type="checkbox" ng-model="ctrl.documentsSelectAll"></label>
            </div>
        </section>

        <section>
            <h2 class="down">{{'admin.workflows.transferOwnership.newOwners'|translate}}</h2>
            <div class="list new-owner-list">
                <div class="list-filter list-filter-tools">
                    <div centuri-list-filter class="list-filter-elements" config="ctrl.newOwnerFilterConfig" callback="ctrl.newOwnerFilterCallback"></div>
                </div>
                <div id="new-owner-list-component"></div>
            </div>
            <div class="options" ng-if="ctrl.newOwnerId">
                <label><span>{{'admin.workflows.ownershipTransfer.workUnits'|translate}}</span><select ng-model="ctrl.selectedWorkUnit" ng-options="option.text for option in ctrl.workUnits track by option.value"></select></label>
            </div>
        </section>

        <section class="last">
            <h2 class="down">{{'admin.workflows.transferOwnership.messageToNewOwner'|translate}}</h2>
            <div class="new-owner-message">
                <div class="options">
                    <label><span>{{'admin.workflows.transferOwnership.notifyRecipients'|translate}}</span><input type="checkbox" ng-model="ctrl.notify"></label>
                </div>
                <textarea ng-model="ctrl.notifyMessage"></textarea>
            </div>
        </section>
    </div>

    <div class="spacer" />
</div>